define('SageDotCom/Components/SupportedBanksListing',["jquery",
    "SageDotCom/Utility/sanitizer"],
    function ($, sanitizer) {
        function SupportedBanksListing(scope, bankList,
            show30MoreButtonText, showRemainingButtonText, typeAheadMoreResultsText, resultsPagingText, loadingText) {
            var allBanks = bankList;
            var component = $(".supported-banks-listing", scope);
            var searchButton = $(".bank-feed-search-submit", scope);
            var searchBox = component.find("input");
            // set max length for search input field
            searchBox.attr("maxlength", "50");
            var bankNames = [];
            var $resultsList = component.find(".banks-results");
            var $moreResults = component.find(".banks-results .more-results");
            var $refine = component.find(".refine");
            var $resultsWrapper = component.find(".banks-results-wrapper");
            var $noResultsWrapper = component.find(".banks-no-results-wrapper");
            var $showMore = component.find(".show-more-banks-result");
            var $searchInput = component.find(".bank-feed-search-input");
            var $searchIcon = component.find(".search-icon-container");
            var selectDropdown = component.find(".bank-feed-product-select");
            var loadMoreButton = component.find(".bank-feed-load-more");
            var loadMoreButtonText = loadMoreButton.find("span.bank-feed-load-more");
            var resultCountText = component.find(".result-count");
            var banksToDisplay = [];
            let locale = undefined;
            const localeArr = document.location.pathname.split("/");
            for (let i = 0; i < localeArr.length; i++) {
                if (localeArr[i] !== "") {
                    locale = localeArr[i].split("-")[1];
                    break;
                }
            }

            if (allBanks !== null) {
                $.each(allBanks, function (i, bank) {
                    bankNames.push(sanitizer.stripHtml(bank.Name));
                });
            }
            banksToDisplay = bankNames;
            if (allBanks.length > 60) {
                loadMoreButton.removeClass("hidden");
                loadMoreButtonText = show30MoreButtonText;
            }
            else if (allBanks.length < 60 && allBanks.length > 30) {
                loadMoreButton.removeClass("hidden");
                loadMoreButtonText = showRemainingButtonText;
            } else {
                loadMoreButton.addClass("hidden");
            }

            var substringMatcher = function (strs) {
                return function findMatches(q, cb) {
                    var matches, substringRegex;

                    // an array that will be populated with substring matches
                    matches = [];

                    q = q.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

                    substringRegex = new RegExp(q, 'i');
                    // iterate through the pool of strings and for any string that
                    // contains the substring `q`, add it to the `matches` array
                    $.each(strs, function (i, str) {
                        if (substringRegex.test(str)) {
                            matches.push(str);
                        }
                    });

                    cb(matches);
                };
            };
            declareTypeahead(banksToDisplay);
            function ClickHandle() {
                $resultsList.empty();
                $moreResults.empty();
                $refine.addClass("hidden");
                $resultsWrapper.addClass("hidden");
                loadMoreButton.addClass("hidden");

                var searchStr = $searchInput[0].value;
                var matches = [];

                // regex used to determine if a string contains the substring `q`
                searchStr = searchStr.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
                if (searchStr !== "") {
                    var substrRegex = new RegExp(searchStr, 'i');
                    // iterate through the pool of strings and for any string that
                    // contains the substring `q`, add it to the `matches` array
                    $.each(bankNames, function (i, bank) {
                        if (bank.match(substrRegex)) {
                            matches.push(bank);
                        }
                    });
                }
                banksToDisplay = bankNames;
                if (searchStr !== "") {
                    banksToDisplay = matches;
                }
                if (banksToDisplay.length) {
                    $resultsWrapper.removeClass("hidden");
                    $noResultsWrapper.addClass("hidden");
                    resultCountText.removeClass("hidden");

                    var limit = banksToDisplay.length - 1 > 29 ? 29 : banksToDisplay.length - 1;
                    for (var i = 0; i <= limit; i++) {
                        $resultsList.append('<div class="bank-item"><p class="bank-name">' + banksToDisplay[i] + '</p></div>');
                    }
                    if (banksToDisplay.length >= 60) {
                        loadMoreButton.removeClass("hidden");
                        loadMoreButton.find("span.bank-feed-load-more")[0].innerText = show30MoreButtonText;
                        loadMoreButtonText = show30MoreButtonText;
                        resultCountText[0].innerText = resultsPagingText.replace("{0}", "30").replace("{1}", banksToDisplay.length);

                    } else if (banksToDisplay.length > 30) {
                        loadMoreButton.removeClass("hidden");
                        loadMoreButton.find("span.bank-feed-load-more")[0].innerText = showRemainingButtonText;
                        loadMoreButtonText = showRemainingButtonText;
                        var alreadyDisplayingNumberOfItems = $resultsList.find(".bank-item").length;
                        resultCountText[0].innerText = resultsPagingText.replace("{0}", alreadyDisplayingNumberOfItems).replace("{1}", banksToDisplay.length);
                    } else {
                        var alreadyDisplayingNumberOfItems = $resultsList.find(".bank-item").length;
                        resultCountText[0].innerText = resultsPagingText.replace("{0}", alreadyDisplayingNumberOfItems).replace("{1}", banksToDisplay.length);
                    }
                } else {
                    resultCountText.addClass("hidden");
                    $resultsWrapper.addClass("hidden");
                    $noResultsWrapper.removeClass("hidden");
                }
            }
            function declareTypeahead(banksToDisplay) {
                searchBox.typeahead({
                    hint: false,
                    highlight: false,
                    minLength: 3
                },
                    {
                        name: 'banks',
                        source: substringMatcher(banksToDisplay),
                        limit: 8
                    }).bind("typeahead:select", function (e, selection) {
                        $(this).typeahead('close');
                        $searchInput[0].value = selection;
                        ClickHandle();
                    }).bind('typeahead:render', function (e, datum) {
                        var searchStr = $searchInput[0].value;
                        var matches = [];

                        // regex used to determine if a string contains the substring `q`
                        searchStr = searchStr.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

                        var substrRegex = new RegExp(searchStr, 'i');
                        // iterate through the pool of strings and for any string that
                        // contains the substring `q`, add it to the `matches` array
                        $.each(banksToDisplay,
                            function (i, bank) {

                                if (bank.match(substrRegex)) {
                                    matches.push(bank);

                                }
                            });
                        if (matches.length) {
                            var limit = matches.length - 1 > 7 ? 7 : matches.length - 1;

                            if (limit === 7) {
                                var more = matches.length - 8;
                                if (component.find('.tt-dataset.tt-dataset-banks .tt-suggestion.bold').length > 0) {
                                    component.find('.tt-dataset.tt-dataset-banks .tt-suggestion.bold')[0].innerText = typeAheadMoreResultsText.replace("{0}", more);
                                } else {
                                    component.find('.tt-dataset.tt-dataset-banks').append('<div class="tt-suggestion bold">' + typeAheadMoreResultsText.replace("{0}", more) + '<div>');
                                }
                            }
                        }

                    });
            }
            
            $searchInput.keyup(function (event) {
                // don't do anything if the search term is not entered
                if (event.which === 13 && event.currentTarget.value.length !== 0) {
                    $(this).typeahead('close');
                    ClickHandle();
                }
            });
            $searchIcon.on("click keydown", function (event) {
                if (event.keyCode === 13 || event.type === "click") {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    ClickHandle();
                }
            });
            searchButton.on("click keydown", function (event) {
                if ((event.keyCode === 13 || event.type === "click") && event.currentTarget.value.length !== 0) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    ClickHandle();
                }
            });
            $showMore.on("click", function (event) {
                $moreResults.removeClass("hidden");
            });

            selectDropdown.on("change", function () {
                var selectedProduct = selectDropdown.val();
                $searchInput[0].value = "";
                if (selectedProduct === "placeholder") {
                    bankNames = [];
                    if (allBanks !== null) {
                        $.each(allBanks, function (i, bank) {
                            bankNames.push(sanitizer.stripHtml(bank.Name));
                        });
                    }
                    searchBox.typeahead("destroy");
                    declareTypeahead(bankNames);
                    ClickHandle();
                } else {
                    if (component.find(".loader").length === 0) {

                        addSpinner($resultsList);
                    }
                    getBankList(selectedProduct);
                }
                


            });
            loadMoreButton.on("click keydown", function (event) {
                if ((event.keyCode === 13 || event.type === "click")) {
                    if (loadMoreButtonText === show30MoreButtonText) {
                        for (var i = 30; i <= 59; i++) {
                            $resultsList.append('<div class="bank-item"><p class="bank-name">' + banksToDisplay[i] + '</p></div>');
                        }
                        if (banksToDisplay.length > 60) {
                            loadMoreButton.find("span.bank-feed-load-more")[0].innerText = showRemainingButtonText;
                            loadMoreButtonText = showRemainingButtonText;
                        } else {
                            loadMoreButton.addClass("hidden");
                        }

                    } else if (loadMoreButtonText === showRemainingButtonText) {
                        var alreadyDisplayingNumberOfItems = $resultsList.find(".bank-item").length;
                        for (var i = alreadyDisplayingNumberOfItems; i < banksToDisplay.length; i++) {
                            $resultsList.append('<div class="bank-item"><p class="bank-name">' + banksToDisplay[i] + '</p></div>');
                        }
                        loadMoreButton.addClass("hidden");
                    }
                    var alreadyDisplayingNumberOfItems = $resultsList.find(".bank-item").length;
                    resultCountText[0].innerText = resultsPagingText.replace("{0}", alreadyDisplayingNumberOfItems).replace("{1}", banksToDisplay.length);
                }
            });
            function getBankList(productFilter) {
                return $.ajax({
                    url: "/api/bank/getbanksperproduct",
                    type: "GET",
                    data: {
                        productFilter: productFilter,
                        locale: locale
                    },
                    success: function (response) {
                        if (response !== "") {
                            var jsonObj = JSON.parse(response);
                            bankNames = [];
                            $.each(jsonObj, function (i, bank) {
                                bankNames.push(sanitizer.stripHtml(bank.Name));
                            });
                            
                            searchBox.typeahead("destroy");
                            declareTypeahead(bankNames);
                            ClickHandle();
                            removeSpinner($resultsWrapper);
                        } else {
                            if (response === "") {
                                bankNames = [];
                                searchBox.typeahead("destroy");
                                declareTypeahead(bankNames);
                                ClickHandle();
                                removeSpinner($resultsWrapper);
                            }
                        }
                    }
                });
            }


            function addSpinner(context) {
                context.after("<div class='loader'></div>");
                var spinner = context.find(".loader");
                component.find(".loader").after("<p class='loading-text'>" + loadingText + "</p>");
                spinner != null && spinner != undefined ? spinner.insertBefore(spinner.prev()) : spinner;
                
            }

            function removeSpinner(context) {
                var spinner = context.find(".loader");
                var loading = context.find(".loading-text");
                spinner != null && spinner != undefined ? spinner.remove() : spinner;
                loading != null && loading != undefined ? loading.remove() : loading;
            }
        }

        SupportedBanksListing.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new SupportedBanksListing(args.scope, args.bankList,
                    args.show30MoreButtonText, args.showRemainingButtonText, args.typeAheadMoreResultsText, args.resultsPagingText, args.loadingText);
        };

        return SupportedBanksListing;
    });

